import './servicessection.css'
import { Link } from 'react-router-dom'

const ServicesSection = ({ search }) => {
    return (
        <div className="services-area pt-100 pb-100">
            <div className="container">
                <div className="section-title">
                    <span className="top-title">Our Services</span>
                    <h2>Professional Services</h2>
                    {search && <div className="service-search mt-3">
                        <form className="search-form">
                            <input
                                required
                                className="search-input"
                                name="search"
                                placeholder="Search..."
                                type="text" />
                            <button type="submit" className="search-button"><i className="flaticon-search"></i></button>
                        </form>
                    </div>}
                </div>
                <div className="row justify-content-center">
                    {Array(3).fill().map(() => (
                        <div className="col-lg-4 col-sm-6 col-md-6">
                            <div className="single-services-card" >
                                <div className="d-flex justify-content-between">
                                    <div className="services-icon">
                                        <img src="https://fiverr-res.cloudinary.com/t_gig_cards_web,q_auto,f_auto/gigs/138196807/original/9e69033f25a157d1c1eb339440d9eebd956b4396.jpg" alt="" />
                                    </div>
                                    <div className="services-user-pic">
                                        <img src="https://templates.hibotheme.com/bixu/default/assets/images/team/team-img-2.png" alt="" />
                                    </div>
                                </div>
                                <Link to="/services-detail">
                                    <h3>House Cleaning</h3>
                                </Link>
                                <p className="d-flex justify-content-between align-items-center">
                                    <span><strong>Price</strong>: $100</span>
                                    <a className="learn-more">5.0(11)</a>
                                </p>
                                <Link to="/services-detail" className="learn-more">View <i className="flaticon-next"></i></Link>
                            </div>
                        </div>
                    ))}
                </div>
                {window.location.pathname !== '/services' && <div className="view-all-btn">
                    <Link to="/services" className="default-btn btn-style-one">View All</Link>
                </div>}
            </div>
        </div>
    )
}

export default ServicesSection